import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import { Reward } from "./pages/Reward";
import { CustomerEdit } from "./pages/CustomerEdit";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { History } from "./pages/History";
import { Home } from "./pages/Home";
import { ManualTopup } from "./pages/ManualTopup";
import { Map } from "./pages/Map";
import { Scan } from "./pages/Scan";
import { Flyer } from "./pages/Flyer";
import { MapDetail } from "./pages/MapDetail";
import { Terms } from "./pages/Terms";
import { Rally } from "./pages/Rally";
import { RallyDetail } from "./pages/RallyDetail";
import { NoticeProvider } from "./context/NoticeContext";
import { CustomerInfoProvider } from "./context/CustomerInfoContext";
import CustomAxios from "./utils/CustomAxios";

// リダイレクト用のコンポーネント
const IssuerIdRedirect = () => {
  const { issuerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!issuerId) return;

    // パラメータとナビゲーション先を決定
    let apiPath = issuerId;
    let params: { solt?: string } = {};

    if (issuerId.includes("M20") && issuerId.includes(".")) {
      const sereal = issuerId.split(".")[0];
      const solt = issuerId.split(".")[1];
      apiPath = sereal;
      params = { solt: solt };
    }

    // 共通のAPI呼び出し
    CustomAxios.get(`/issuer/alwaysQrInfo/${apiPath}`, { params })
      .then((res) => {
        if (params.solt) {
          // M20の場合の特別なナビゲーション
          navigate(
            `/map/${res.data.issuerId}?number=${res.data.number}&solt=${params.solt}`
          );
        } else {
          // 通常のナビゲーション
          navigate(`/map/${res.data.issuerId}`);
        }
      })
      .catch(() => {
        navigate("/");
      });
  }, [issuerId, navigate]);

  // リダイレクト中は何も表示しない
  return null;
};

export const App = () => {
  return (
    <CustomerInfoProvider>
      <NoticeProvider>
        <BrowserRouter>
          <div className="app">
            <Header />
            <Routes>
              <Route path="*" element={<Home />} />
              <Route path="/scan" element={<Scan />} />
              <Route path="/map">
                <Route index={true} element={<Map />} />
                <Route path="/map/:issuerId" element={<MapDetail />} />
              </Route>
              <Route path="/flyer" element={<Flyer />} />
              <Route path="/reward" element={<Reward />} />
              <Route path="/history" element={<History />} />
              <Route path="/manual-topup" element={<ManualTopup />} />
              <Route path="/customer-edit" element={<CustomerEdit />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/rally">
                <Route index={true} element={<Rally />} />
                <Route path="/rally/:rallyId" element={<RallyDetail />} />
              </Route>
              <Route path="/:issuerId" element={<IssuerIdRedirect />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </NoticeProvider>
    </CustomerInfoProvider>
  );
};
